import { TbCashBanknote, TbList, TbTicket } from "react-icons/tb";
import { ShortcutCard } from "../../Atoms/ShortcutCard";
import { useAuth } from "../../../Contexts/AuthContext";

export const PaymentsShortcutMenu = ({ onFocusBarcode }) => {
  const { hasPermission } = useAuth();

  const items = [
    {
      label: "Pagar boleto",
      icon: TbCashBanknote,
      onClick: onFocusBarcode,
      permission: "payboleto",
    },
    {
      label: "Emitir boleto",
      icon: TbTicket,
      path: "/boletos/add",
      permission: "boletocreateview",
    },
    {
      label: "Meus boletos",
      icon: TbList,
      path: "/boletos",
      permission: "boletocreateview",
    },
  ];

  const visible = items.filter(
    (item) => !item.permission || hasPermission(item.permission)
  );

  if (!visible.length) return null;

  return (
    <section className="mb-5 min-w-0 overflow-hidden">
      <h2 className="dashboard-section-label mb-3">Pagamentos</h2>
      <div className="shortcut-scroll-row">
        {visible.map(({ label, icon, path, onClick }) => (
          <ShortcutCard
            key={label}
            to={path}
            onClick={onClick}
            icon={icon}
            label={label}
          />
        ))}
      </div>
    </section>
  );
};
